import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/boymep/danilpanov/node_modules/.pnpm/next-intl@3.26.5_next@14.2.32_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.90.0__react@18.3.1/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/node_modules/.pnpm/next@14.2.32_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.90.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/node_modules/.pnpm/next@14.2.32_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.90.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"cyrillic\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/src/app/[locale]/layout.module.scss");
;
import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/src/components/Vignette/Vignette.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/boymep/danilpanov/src/hooks/useTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WithRedux"] */ "/home/boymep/danilpanov/src/providers/WithRedux.tsx");
;
import(/* webpackMode: "eager" */ "/home/boymep/danilpanov/src/styles/globals.scss");
